import React from 'react';
import { useFormContextRequired, useShowContextRequired } from 'ui-builder';
import { EmailTask, ProjectDocument } from 'nekst-api';
import Layout from './Layout';

export default function FilePreviewRow() {

  const showContext = useShowContextRequired<ProjectDocument>();

  const formContext = useFormContextRequired<EmailTask>();

  return (
    <Layout
      document={showContext.data!}
      onDelete={() => {
        formContext.onChangeCallback!({
          attachedDocumentsIds: formContext.data!.attachedDocumentsIds.filter((id) => id !== showContext.data!.id),
          _attachedDocuments: formContext.data!._attachedDocuments.filter((doc) => doc.id !== showContext.data!.id),
        });
      }}
      withSize
    />
  );
}
